"use strict";

export default function () {
    const hamburguer = document.querySelector(".hamburguer-menu");
    const body = document.body;
    const header = document.querySelector(".o-header");
    const menu = document.querySelector(".mobile-menu");

    if (!hamburguer || !menu || !header) return;

    hamburguer.addEventListener("click", () => {
        const isActive = menu.classList.toggle("active");
        header.classList.toggle("active", isActive);

        body.style.overflow = isActive ? "hidden" : "auto";
        header.style.boxShadow = isActive ? "none" : "";
        header.style.borderColor = isActive ? "rgba(196, 196, 196, 0.40)" : "";
    });
}
